export const Period = {
  DAY: 'day',
  HOUR: 'hour',
  MONTH: 'month'
}